import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PaymentService } from '../../../shared/services/payment.service';
import { PaymentModel } from '../../../model/payment.model';
import { SessionService } from '../../../shared/services/session.service';
import { UserDto } from '../../../model/user/user-dto';
import { ActivatedRoute, Router } from '@angular/router';
import { PaymentMethod } from '../../../model/payment-method';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TextService } from '../../../shared/services/text.service';
import { MessageService } from '../../../shared/services/message-service';
import { SdkInitText } from '../../../model/user/sdk-init-text';
import { UserService } from '../../../shared/services/user.service';
import { NetmeraService } from "../../../shared/services/netmera-service";

@Component({
  selector: 'pa-payment-selection',
  templateUrl: './payment-selection.component.html',
  styleUrls: ['./payment-selection.component.scss'],
})

export class PaymentSelectionComponent implements OnInit {

  paymentInformation: PaymentMethod;
  paymentModel: PaymentModel;
  user: UserDto;
  textService: TextService;
  message: string;
  cvv: string;
  showReadyLimit: boolean;
  showBalance: boolean;
  trackingId: string;
  sdkInitTexts: Array<SdkInitText>;

  constructor(private router: Router, private route: ActivatedRoute, private paymentService: PaymentService, private sessionService: SessionService, private userService: UserService,
              private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer, private changeDetectorRef: ChangeDetectorRef,
              textService: TextService, private messageService: MessageService, private netmeraService: NetmeraService) {
    this.textService = textService;
    this.matIconRegistry.addSvgIcon('info', this.domSanitizer.bypassSecurityTrustResourceUrl('assets/images/svg/info.svg'));
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.trackingId = params.trackingId;
    });
    this.getPaymentMethods();
  }

  getPaymentMethods() {
    this.paymentService.getPaymentMethods(this.trackingId).subscribe(response => {
      this.getUser();
      this.paymentModel = response;
      this.message = this.messageService.getMessage();
      this.messageService.setMessage(null);
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

  getUser() {
    this.sessionService.getInitUser(this.trackingId).subscribe(response => {
      if (response != null) {
        this.user = response;
        this.netmeraService.setUser(this.user?.account?.externalId);
        this.sdkInitTexts = response.sdkInitTexts;
        this.balanceShowCheck();
        this.readyLimitShowCheck();
      }
    }, error => {
      this.router.navigate(['/result/error', this.trackingId]);
    });
  }

  balanceShowCheck() {
    const KEY = 'LINKED_PAYCELL_CARD';
    this.user?.paymentMethods?.forEach(paymentMethod => {
      if (paymentMethod?.isSingle === '1') {
        //this.showBalance = this.user?.showInfos.indexOf(KEY) != -1;
        this.showBalance = true;
        if(this.showBalance) {
          this.changeDetectorRef.detectChanges();
          /*
          * //this.showBalance = this.user?.showInfos.indexOf(KEY) != -1; açıldığı zaman altta ki kod açılmalı
          * */
          //this.updateAccountInfoMsg(KEY);
        }
      }
    });
  }

  readyLimitShowCheck() {
    const KEY = 'READY_LIMIT';
    this.user?.paymentMethods?.forEach(paymentMethod => {
      if (paymentMethod?.paymentMethodType === 'DCB') {
        //this.showReadyLimit = this.user?.showInfos.indexOf(KEY) != -1;
        this.showReadyLimit = true;
        if(this.showReadyLimit) {
          this.changeDetectorRef.detectChanges();
          /*
          * //this.showReadyLimit = this.user?.showInfos.indexOf(KEY) != -1; açıldığı zaman altta ki kod açılmalı
          * */
          //this.updateAccountInfoMsg(KEY);
        }
      }
    });
  }

  updateAccountInfoMsg(key: string) {
    this.userService.updateAccountInfoMg(this.trackingId, key).subscribe(response => {

    });
  }

  readyLimitClose() {
    this.showReadyLimit = false;
  }

  balanceClose() {
    this.showBalance = false;
  }

  carouselChange(event: any) {
    this.paymentInformation = event;
  }

  cvvPassByValue(event: any) {
    this.cvv = event;
  }

  errorMessage(event:any) {
    this.message = event;
  }

  messageState(value: any) {
    this.message = value;
  }
}
